import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["star", "input", "textarea", "status"];

    connect() {
        this.selected = parseInt(this.inputTarget.value || "0", 10);
        this.hovered = 0;
        this.render();
    }

    preview(event) {
        const value = parseInt(event.params.value, 10);
        this.hovered = value;
        this.render();
    }

    clearPreview() {
        this.hovered = 0;
        this.render();
    }

    select(event) {
        const value = parseInt(event.params.value, 10);
        this.selected = value;
        this.inputTarget.value = String(value);
        this.render();
    }

    render() {
        const active = this.hovered || this.selected || 0;
        this.starTargets.forEach((btn, idx) => {
            const val = idx + 1;
            const isActive = val <= active;
            btn.classList.toggle("is-active", isActive);
            btn.setAttribute("aria-pressed", isActive ? "true" : "false");
        });
    }
}
